import { render, staticRenderFns } from "./AppFooterLeft.vue?vue&type=template&id=19a5b91b&"
import script from "./AppFooterLeft.vue?vue&type=script&lang=js&"
export * from "./AppFooterLeft.vue?vue&type=script&lang=js&"
import style0 from "./AppFooterLeft.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports